module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-4-161b906380dfa18dbb25554bbdec39bb.jpg";